import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetData } from '../selectors/dataSelector'
import GroupedBarChart from './GroupedBarChart'
import Immutable from 'seamless-immutable'

const styles = theme => ({})

class InfrastructureBufferChart extends PureComponent {
  render () {
    const { data } = this.props

    if (!arrayIsNotEmpty(data)) {
      return null
    }
    const names = Array.from(new Set(data.map(datum => datum.name)))
    const groupByFilters = names.map(name => item => item.name === name)

    return (
      <GroupedBarChart
        data={data}
        groupByFilters={groupByFilters}
        categories={{ x: ['Commercial', 'Garage', 'Residential', 'Trailer'] }}
        legendCategories={[
          { name: 'Commercial' },
          { name: 'Garage' },
          { name: 'Residential' },
          { name: 'Trailer' }
        ]}
      />
    )
  }
}

const transformDatetime = data => {
  const reducedData = data.reduce((object, item) => {
    const key = item.name
    const timestamp = item.timestamp
    if (!object[timestamp]) {
      object[timestamp] = {}
    }
    const prevCount = object[timestamp][key]
    object[timestamp][key] = prevCount ? prevCount + 1 : 1

    return object
  }, {})

  const arrayData = Object.keys(reducedData).map(datetime =>
    Object.keys(reducedData[datetime]).map(key => ({
      x: datetime.slice(0, 4),
      y: reducedData[datetime][key],
      datetime: datetime,
      name: key
    }))
  )

  return Immutable(
    [].concat(...arrayData).sort((a, b) => a.name.localeCompare(b.name))
  )
}

const makeMapStateToProps = () => {
  const getData = makeGetData()
  const mapStateToProps = state => {
    return {
      data: getData(state, 'InfrastructureBuffer', transformDatetime)
    }
  }
  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(
  withStyles(styles)(InfrastructureBufferChart)
)



// WEBPACK FOOTER //
// ./src/charts/InfrastructureBufferChart.js